const getFirstValue = (value) => {
  if (Array.isArray(value)) {
    return value[0] ?? ""
  }
  return value ?? ""
}

const normalizeValue = (value) => {
  const target = getFirstValue(value)
  return target === null || target === undefined ? "" : String(target)
}

const getProductCardCategoryId = (product = {}) => {
  return normalizeValue(
    product.categoryId ??
      product.category_id ??
      product.category?.id
  )
}

const getProductCardOperationCategory = (product = {}) => {
  return normalizeValue(
    product.operationCategoryId ??
      product.operation_category ??
      product.operationCategory?.id
  )
}

export const getProductCardTrackParams = (product = {}) => {
  return {
    productCode: normalizeValue(product.code ?? product.productCode),
    category_id: getProductCardCategoryId(product),
    operation_category: getProductCardOperationCategory(product)
  }
}

export const getProductCardCategoryParams = (product = {}) => {
  const { category_id, operation_category } = getProductCardTrackParams(product)
  return {
    category_id,
    operation_category
  }
}

export const getProductCardCategoryParamsFromQuery = (query = {}, product = {}) => {
  const productParams = getProductCardCategoryParams(product)
  return {
    category_id: normalizeValue(query.category_id ?? query.categoryId) || productParams.category_id,
    operation_category:
      normalizeValue(query.operation_category ?? query.operationCategoryId) ||
      productParams.operation_category
  }
}

export const appendProductCardCategoryQuery = (queryString = "", product = {}) => {
  const params = new URLSearchParams(String(queryString || "").replace(/^\?/, ""))
  const { category_id, operation_category } = getProductCardCategoryParams(product)

  if (category_id) {
    params.set("category_id", category_id)
  }
  if (operation_category) {
    params.set("operation_category", operation_category)
  }

  const query = params.toString()
  return query ? `?${query}` : ""
}

export const buildProductCardTrackSource = (categoryParams = {}) => {
  const params = new URLSearchParams()
  const categoryId = normalizeValue(categoryParams.category_id)
  const operationCategory = normalizeValue(categoryParams.operation_category)

  if (categoryId) {
    params.set("category_id", categoryId)
  }
  if (operationCategory) {
    params.set("operation_category", operationCategory)
  }

  const query = params.toString()
  return query ? `/PRODUCT/CARD/ADDCART?${query}` : "/PRODUCT/CARD/ADDCART"
}

export const parseProductCardTrackSource = (source = "") => {
  const queryString = String(source).split("?")[1]?.split("#")[0] || ""
  if (!queryString) {
    return {
      category_id: "",
      operation_category: ""
    }
  }

  const params = new URLSearchParams(queryString)
  return {
    category_id: params.get("category_id") || "",
    operation_category: params.get("operation_category") || ""
  }
}
